<template>
    <div class="andamento">
        <Tooltip v-for="(item, key) of lista_andamento" :key="key"
                 @click.native="onSelect ? onSelect(id, item.valor) : ''" :content="item.nome" placement="top"
                 :style="{margin: '0 2px', cursor: (onSelect ? 'pointer' : 'default')}">
            <span :class="( andamento >= item.valor ? `circle-radio-checked` : `circle-radio`)"/>
        </Tooltip>
        <span class="info"><span v-if="andamento">{{lista_andamento[andamento-1].nome}}</span><span
                v-else>Não atribuído</span></span>
    </div>
</template>

<script>
    export default {
        name: "pgd-andamento",
        props: {
            id: Number,
            onSelect: Function,
            andamento: Number
        },
        data() {
            return {
                lista_andamento: [
                    {
                        nome: "Atribuído",
                        valor: 1
                    },
                    {
                        nome: "Desenvolvimento",
                        valor: 2
                    },
                    {
                        nome: "Análise de Qualidade",
                        valor: 3
                    },
                    {
                        nome: "Em Teste",
                        valor: 4
                    },
                    {
                        nome: "Aguardando Merge",
                        valor: 5
                    },
                    {
                        nome: "Merge Master",
                        valor: 6
                    },
                    {
                        nome: "Em Produção",
                        valor: 7
                    }
                ]
            };
        }
    };
</script>

<style scoped>
    .andamento {
        color: #e91e63;
        font-size: 13px;
        display: inline-block;
    }

    .andamento .info {
        width: 113px;
        text-align: center;
        display: inline-block;
        color: #515a6e;
        font-size: 11px;
    }
</style>

